// extracted by mini-css-extract-plugin
export var closed = "_am-1";
export var resizer = "_am-0";